import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MoveMoneyContext } from '../../context/MoveMoneyContext';
import '../MoveMoney/MoveMoney.css';
import { validateAccount } from '../../api';

const SelectAccount = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const moveMoneyContext = useContext(MoveMoneyContext);

  if (!moveMoneyContext) {
    throw new Error('MoveMoneyContext must be used within a MoveMoneyProvider');
  }

  const {
    fromAccount,
    setFromAccount,
    amount,
    accounts
  } = moveMoneyContext;

  const handleNext = async () => {
    if (fromAccount) {
      setIsLoading(true);
      const { success } = await validateAccount(fromAccount, amount);
      setIsLoading(false);
      if (success) {
        navigate('/move-money/payment-methods');
      } else {
        alert('There was an issue with the selected account.');
      }
    } else {
      alert('Please select an account.');
    }
  };

  const handleBack = () => {
    navigate('/move-money/amount');
  };

  const formatBalance = (balance: number, currency: string = 'USD') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(balance);
  };

  const getAccountDisplayName = (account: any) => {
    return account.accountName || `Account ${account.accountNumber.slice(-4)}`;
  };

  const getAccountDetails = (account: any) => {
    return `${account.currency} • ${formatBalance(account.balance, account.currency)} • ****${account.accountNumber.slice(-4)}`;
  };

  if (!accounts || accounts.length === 0) {
    return (
      <div className="flow-step">
        <h2 className="step-header">Select an Account to Pay From</h2>
        <div className="no-accounts">No accounts found.</div>
      </div>
    );
  }

  return (
    <div className="flow-step">
      <h2 className="step-header">Select an Account to Pay From</h2>
      <ul className="selection-list">
        {accounts.map((account, index) => (
          <li key={`${account.accountNumber}-${index}`} className="selection-item">
            <label>
              <input
                type="radio"
                name="account"
                value={account.accountNumber}
                checked={fromAccount === account.accountNumber}
                onChange={(e) => setFromAccount(e.target.value)}
              />
              <div className="account-info">
                <div className="account-name">{getAccountDisplayName(account)}</div>
                <div className="account-details">{getAccountDetails(account)}</div>
              </div>
            </label>
          </li>
        ))}
      </ul>
      <div className="navigation-buttons">
        <button onClick={handleBack} disabled={isLoading}>Back</button>
        <button onClick={handleNext} disabled={isLoading || accounts.length === 0}>
          {isLoading ? 'Validating...' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default SelectAccount;
